import Popover from "./Popover";
import withBaseClass from "./withBaseClass";

export default withBaseClass(Popover, "si-c-tooltip");
